import {
  Else,
  If,
  Then,
} from 'react-if';
import { accountingSystemProvider } from 'shared';

import { Spinner } from '../Common/Spinner';
import { useGetSelectedOrganisation } from '../../hooks/useGetSelectedOrganisation';
import { Paragraph } from '../../../common/Atoms/Typography/Paragraph';
import { useAccountingSystemName } from '../../hooks/useAccountingSystemName';
import { useAccountingResources } from '../../hooks/useAccountingResources';
import { TwoColFormRow } from '../Molecules/Form/TwoColFormRow';
import { AccountingConnectButton } from '../AccountingConnectButton';

import { DisconnectButton } from './DisconnectButton';

export function ConnectionSettings() {
  const accountingSystemName = useAccountingSystemName();
  const { data: accountingResources, isLoading  } = useAccountingResources();
  const currentOrg = useGetSelectedOrganisation();

  if (!currentOrg || isLoading) {
    return <Spinner />;
  }

  return (
    <TwoColFormRow
      heading={ `Accounting Connection` }
      description={ `The accounting system this organisation is connected to.` }
    >
      <If condition={ !!accountingSystemProvider(currentOrg)?.connectSlug && !accountingResources }>
        <Then>
          <Paragraph> { `We have detected a problem connecting to ` }{ currentOrg.legalName } { ` please reconnect.` }</Paragraph>
          <div className={ `mt-4` }>
            <AccountingConnectButton type={ currentOrg.type } />
          </div>
        </Then>
        <Else>
          <Paragraph> <span className={ `text-lg font-bold` }>{ `Connected to organisation: ` }</span> <span className={ `text-lg` }>{ `${ currentOrg.legalName }` }</span> </Paragraph>
          <Paragraph> <span className={ `text-lg font-bold` }>{ `Accounting system: ` }</span> <span className={ `text-lg` }>{ `${ accountingSystemName }` }</span> </Paragraph>
          <DisconnectButton />
        </Else>
      </If>
    </TwoColFormRow>
  );
}
